// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1k3Ym","list":"styles_list__oZRMn"};